<template>

<core-card-foot-item>

	<app-view-common-history :history="history" />

	<core-card-foot-item-label>{{ field.label }}</core-card-foot-item-label>

</core-card-foot-item>

</template>

<script>

export default {

	props: ['item', 'field'],

	computed: {

		history: function() {

			if (this.isUser && this.item.revisions) {

				return (this.item.revisions) ? this.item.revisions.history : []

			} else {

				return this.item.trend || []

			}

		}

    }

}

</script>

<style scoped>

</style>
